// 📄 hooks/useTareasPendientesGlobal.ts
// Todas mis tareas vencidas o por vencer en los próximos 7 días, en
// CUALQUIER proyecto — para la campanita del navbar (ver TareasBell.tsx).
import { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext.tsx';
import { subscribeMisTareasGlobal, TareaConProyecto, estaVencida, venceEnProximaSemana } from '../services/tareaService.ts';

export function useTareasPendientesGlobal(): TareaConProyecto[] {
  const { user } = useAuth();
  const [tareas, setTareas] = useState<TareaConProyecto[]>([]);

  useEffect(() => {
    if (!user) { setTareas([]); return; }
    const unsubscribe = subscribeMisTareasGlobal(user.uid, (lista) => {
      setTareas(
        lista
          .filter((t) => estaVencida(t) || venceEnProximaSemana(t))
          .sort((a, b) => a.fechaLimite.localeCompare(b.fechaLimite))
      );
    });
    return () => unsubscribe();
  }, [user]);

  return tareas;
}
